import { sprintf } from "sprintf-js";

export const formatAmount = (amount: number, forceDecimal?: boolean) => {
    const integer = sprintf('%d', Math.floor(amount));
    const decimal = amount % 1 > 0 || forceDecimal ? sprintf(',%02.0f', (amount % 1) * 100) : '';
    return integer + decimal;
}